import {defineMessages} from 'react-intl';

export const congratulationsMessages = defineMessages({
  title: { id: 'congratulations_overlay.title' },
  subtitle: { id: 'congratulations_overlay.subtitle' },
  buttonExplore: { id: 'congratulations_overlay.button_explore' },
  buttonExit: { id: 'congratulations_overlay.button_exit' },
});
